/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
import { apiPost } from 'utils'
import { IbasicsSettings } from 'model'
import { XhhyRequest, XhhyResponse } from 'Xhhy-common/common'
  
  /**
   * 拉取APP基础信息
   * @param params
   */
  export const apiSelectAppBasicInfo = async (params: XhhyRequest) => {
   return await apiPost<XhhyRequest, IbasicsSettings>(`/apppocapi/appbasic/selectAppBasicInfo`, params)
  }

  /**
   * 保存更改
   * @param params
   */
  export const apiSaveupdate = async (params: IbasicsSettings) => {
    return await apiPost<IbasicsSettings, XhhyResponse>(`/apppocapi/appbasic/saveupdate`, params)
  }
  